<ic-auth-wrapper>
	@if (showMfaLogin$ | async) {
		<p class="instructions">{{ "auth.mfa_instruction" | translate }}</p>
	}
	@if (showMfaLogin$ | async) {
		<ic-mfa-login-form [loading]="loading" (changeToken)="onChange()" (totpToken)="onTotpToken($event)">
			@if (invalidCodeError) {
				<p class="message errors" data-test="error-p">
					{{ "auth.errors.mfa_invalid" | translate }}
				</p>
			}
		</ic-mfa-login-form>
	}
	@if (showFailed$ | async) {
		<div class="failed-content">
			<h1 class="title-default">{{ "auth.mfa" | translate }}</h1>
			<i class="fa fa-times-circle-o"></i>
			<p>{{ failedMessage | translate }}</p>
			<ui-double-button class="goto-btn" icon="fa fa-sign-in" type="primary" (action)="goToLogin()">
				{{ "auth.signin" | translate }}
			</ui-double-button>
		</div>
	}
</ic-auth-wrapper>
